export class ConnectAtlasOrganizationResponse {
    'atlasOrganization';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "atlasOrganization",
            "baseName": "atlasOrganization",
            "type": "AtlasOrganization",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ConnectAtlasOrganizationResponse.attributeTypeMap;
    }
    constructor() {
    }
}
